export default __webpack_public_path__ + "static/media/ProximaNova-Alt-Bold.da0d3d7c.otf";